import { routes } from '../constants';
import { safeLocalStorage } from './safeStorage';

export const SEARCH_FEEDBACK_DIALOG_DELAY_MS = 30000;

export const searchFeedbackDialogStorageKeys = {
  submittedAt: 'search_feedback_submitted_at',
  searchQuery: 'search_feedback_search_query',
  shownAt: 'shown_feedback_search_dialog',
} as const;

export const searchFeedbackDialogEvents = {
  submitted: 'search-feedback-submitted',
} as const;

export const getSearchFeedbackDialogShownAt = () => {
  return safeLocalStorage.getItem(searchFeedbackDialogStorageKeys.shownAt);
};

export const setSearchFeedbackDialogShownAt = () => {
  const shownAt = Date.now().toString();
  safeLocalStorage.setItem(searchFeedbackDialogStorageKeys.shownAt, shownAt);
};

const allowedRouteRoots = [
  routes.search.root,
  routes.reader.root,
  routes.productPage.root,
  routes.dashboard.root,
] as const;

export const isSearchFeedbackDialogRouteAllowed = (pathname: string) => {
  return allowedRouteRoots.some((routeRoot) => {
    const routePrefix = `/${routeRoot}`;
    return pathname === routePrefix || pathname.startsWith(`${routePrefix}/`);
  });
};

export const getSearchFeedbackDialogRemainingDelay = (submittedAt: number) => {
  const elapsed = Date.now() - submittedAt;
  return Math.max(SEARCH_FEEDBACK_DIALOG_DELAY_MS - elapsed, 0);
};
